import IntegrationsCallbackPage from './callback';

export default IntegrationsCallbackPage;
